import {IconeTemperatureLivraison} from '@/components/IconeTemperatureLivraison';
import {PolygonDown} from '@/components/svg/PolygonDown';
import {Box, HStack, Text} from '@chakra-ui/layout';
import {Image, VStack} from '@chakra-ui/react';
import {TemperatureDeLivraison} from 'api-types/ffconnect';
import {Trans, useTranslation} from 'react-i18next';
import {PdfBadge} from './PdfBadge';

interface InfoLivraisonProps {
  onClick: () => void;
  date_de_livraison: string;
  nb_article: number;
  active: boolean;
  temperature_tournee?: TemperatureDeLivraison;
  deliveryLabel?: string;
  logoSrc?: string;
  isPanierPdf?: boolean;
}

export const InfoLivraison: React.FC<InfoLivraisonProps> = ({
  onClick,
  date_de_livraison,
  nb_article,
  active,
  temperature_tournee,
  deliveryLabel,
  logoSrc,
  isPanierPdf,
}) => {
  const {t} = useTranslation('common');

  return (
    <Box
      cursor='pointer'
      onClick={onClick}
      userSelect='none'
    >
      <Box
        display={{base: 'flex', lg: 'none'}}
        as={HStack}
        onClick={onClick}
        borderRadius='8px'
        p='3'
        border='1px solid'
        borderColor={active ? 'blue.main' : 'gray.dark'}
        bg={active ? 'lblue.100' : 'transparent.0'}
      >
        {logoSrc ? (
          <Image
            src={logoSrc}
            alt=''
            height='20px'
            objectFit='contain'
            borderRadius='md'
          />
        ) : (
          <IconeTemperatureLivraison
            temperature_tournee={temperature_tournee}
            boxSize={15}
          />
        )}
        <Text textColor={active ? 'blue.main' : 'gray.dark'}>
          {deliveryLabel ?? (
            <Trans t={t}>
              {t('panier.pour_la_livraison_du_mobile', {
                date: new Date(date_de_livraison),
                formatParams: {
                  date: {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  },
                },
              })}
            </Trans>
          )}
        </Text>
        {/* Badge PDF Mobile*/}
        {isPanierPdf && <PdfBadge py='1.5' />}
        <Box
          p='1.5'
          px='2.5'
          borderRadius='8px'
          backgroundColor='gray.light'
          textColor={active ? 'blue.main' : 'gray.dark'}
        >
          {nb_article}
        </Box>
      </Box>
      <Box
        display={{base: 'none', lg: 'block'}}
        as={VStack}
        gap='0'
      >
        <VStack
          alignItems='start'
          textColor='blue.main'
          backgroundColor={active ? 'lblue.100' : 'transparent.0'}
          p='5'
          px='6'
          borderRadius='8px'
          border='1px solid'
          borderColor={active ? 'transparent' : 'gray.light'}
        >
          <Text>
            {deliveryLabel ?? (
              <Trans t={t}>
                {t('panier.pour_la_livraison_du', {
                  date: new Date(date_de_livraison),
                  formatParams: {
                    date: {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    },
                  },
                })}
              </Trans>
            )}
          </Text>
          <HStack fontSize='sm'>
            {logoSrc ? (
              <Image
                src={logoSrc}
                alt=''
                height='30px'
                objectFit='contain'
                borderRadius='md'
              />
            ) : (
              <IconeTemperatureLivraison
                temperature_tournee={temperature_tournee}
                boxSize={15}
              />
            )}
            {/* Badge PDF Desktop*/}
            {isPanierPdf && (
              <PdfBadge
                py='1.5'
                backgroundColor={active ? 'white' : 'gray.light'}
                fontWeight={active ? '600' : '400'}
              />
            )}
            <Box
              p='1.5'
              px='2.5'
              borderRadius='8px'
              backgroundColor={active ? 'transparent.50' : 'gray.light'}
              color='blue.main'
            >
              {t('global.produit', {count: nb_article})}
            </Box>
            {!deliveryLabel && (
              <Box
                p='1.5'
                px='2.5'
                borderRadius='8px'
                backgroundColor='yellow.warning'
                color='yellow.warning_text'
              >
                {t('global.a_valider')}
              </Box>
            )}
          </HStack>
        </VStack>
        <VStack
          mt='-1px'
          h='14px'
        >
          {active && <PolygonDown />}
        </VStack>
      </Box>
    </Box>
  );
};
